import { z as t } from "zod";
const _ = {
  version: {
    _cldrVersion: "26",
    _number: "$Revision: 8817 $"
  },
  generation: {
    _date: "$Date: 2013-05-30 17:53:09 -0500 (Thu, 30 May 2013) $"
  },
  postalCodeData: {
    AD: "AD\\d{3}",
    AM: "(37)?\\d{4}",
    AR: "([A-HJ-NP-Z])?\\d{4}([A-Z]{3})?",
    AS: "96799",
    AT: "\\d{4}",
    AU: "\\d{4}",
    AX: "22\\d{3}",
    AZ: "\\d{4}",
    BA: "\\d{5}",
    BB: "(BB\\d{5})?",
    BD: "\\d{4}",
    BE: "\\d{4}",
    BG: "\\d{4}",
    BH: "((1[0-2]|[2-9])\\d{2})?",
    BM: "[A-Z]{2}[ ]?[A-Z0-9]{2}",
    BN: "[A-Z]{2}[ ]?\\d{4}",
    BR: "\\d{5}[\\-]?\\d{3}",
    BY: "\\d{6}",
    CA: "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d",
    CC: "6799",
    CH: "\\d{4}",
    CK: "\\d{4}",
    CL: "\\d{7}",
    CN: "\\d{6}",
    CR: "\\d{4,5}|\\d{3}-\\d{4}",
    CS: "\\d{5}",
    CV: "\\d{4}",
    CX: "6798",
    CY: "\\d{4}",
    CZ: "\\d{3}[ ]?\\d{2}",
    DE: "\\d{5}",
    DK: "\\d{4}",
    DO: "\\d{5}",
    DZ: "\\d{5}",
    EC: "([A-Z]\\d{4}[A-Z]|(?:[A-Z]{2})?\\d{6})?",
    EE: "\\d{5}",
    EG: "\\d{5}",
    ES: "\\d{5}",
    ET: "\\d{4}",
    FI: "\\d{5}",
    FK: "FIQQ 1ZZ",
    FM: "(9694[1-4])([ \\-]\\d{4})?",
    FO: "\\d{3}",
    FR: "\\d{2}[ ]?\\d{3}",
    GB: "GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4}",
    GE: "\\d{4}",
    GF: "9[78]3\\d{2}",
    GG: "GY\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}",
    GL: "39\\d{2}",
    GN: "\\d{3}",
    GP: "9[78][01]\\d{2}",
    GR: "\\d{3}[ ]?\\d{2}",
    GS: "SIQQ 1ZZ",
    GT: "\\d{5}",
    GU: "969[123]\\d([ \\-]\\d{4})?",
    GW: "\\d{4}",
    HM: "\\d{4}",
    HN: "(?:\\d{5})?",
    HR: "\\d{5}",
    HT: "\\d{4}",
    HU: "\\d{4}",
    ID: "\\d{5}",
    IL: "\\d{5}",
    IM: "IM\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}",
    IN: "\\d{6}",
    IO: "BBND 1ZZ",
    IQ: "\\d{5}",
    IS: "\\d{3}",
    IT: "\\d{5}",
    JE: "JE\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}",
    JO: "\\d{5}",
    JP: "\\d{3}-\\d{4}",
    KE: "\\d{5}",
    KG: "\\d{6}",
    KH: "\\d{5}",
    KR: "\\d{3}[\\-]\\d{3}",
    KW: "\\d{5}",
    KZ: "\\d{6}",
    LA: "\\d{5}",
    LB: "(\\d{4}([ ]?\\d{4})?)?",
    LI: "(948[5-9])|(949[0-7])",
    LK: "\\d{5}",
    LR: "\\d{4}",
    LS: "\\d{3}",
    LT: "\\d{5}",
    LU: "\\d{4}",
    LV: "\\d{4}",
    MA: "\\d{5}",
    MC: "980\\d{2}",
    MD: "\\d{4}",
    ME: "8\\d{4}",
    MG: "\\d{3}",
    MH: "969[67]\\d([ \\-]\\d{4})?",
    MK: "\\d{4}",
    MN: "\\d{6}",
    MP: "9695[012]([ \\-]\\d{4})?",
    MQ: "9[78]2\\d{2}",
    MT: "[A-Z]{3}[ ]?\\d{2,4}",
    MU: "(\\d{3}[A-Z]{2}\\d{3})?",
    MV: "\\d{5}",
    MX: "\\d{5}",
    MY: "\\d{5}",
    NC: "988\\d{2}",
    NE: "\\d{4}",
    NF: "2899",
    NG: "(\\d{6})?",
    NI: "((\\d{4}-)?\\d{3}-\\d{3}(-\\d{1})?)?",
    NL: "\\d{4}[ ]?[A-Z]{2}",
    NO: "\\d{4}",
    NP: "\\d{5}",
    NZ: "\\d{4}",
    OM: "(PC )?\\d{3}",
    PF: "987\\d{2}",
    PG: "\\d{3}",
    PH: "\\d{4}",
    PK: "\\d{5}",
    PL: "\\d{2}-\\d{3}",
    PM: "9[78]5\\d{2}",
    PN: "PCRN 1ZZ",
    PR: "00[679]\\d{2}([ \\-]\\d{4})?",
    PT: "\\d{4}([\\-]\\d{3})?",
    PW: "96940",
    PY: "\\d{4}",
    RE: "9[78]4\\d{2}",
    RO: "\\d{6}",
    RS: "\\d{6}",
    RU: "\\d{6}",
    SA: "\\d{5}",
    SE: "\\d{3}[ ]?\\d{2}",
    SG: "\\d{6}",
    SH: "(ASCN|STHL) 1ZZ",
    SI: "\\d{4}",
    SJ: "\\d{4}",
    SK: "\\d{3}[ ]?\\d{2}",
    SM: "4789\\d",
    SN: "\\d{5}",
    SO: "\\d{5}",
    SZ: "[HLMS]\\d{3}",
    TC: "TKCA 1ZZ",
    TH: "\\d{5}",
    TJ: "\\d{6}",
    TM: "\\d{6}",
    TN: "\\d{4}",
    TR: "\\d{5}",
    TW: "\\d{3}(\\d{2})?",
    UA: "\\d{5}",
    US: "\\d{5}([ \\-]\\d{4})?",
    UY: "\\d{5}",
    UZ: "\\d{6}",
    VA: "00120",
    VE: "\\d{4}",
    VI: "008(([0-4]\\d)|(5[01]))([ \\-]\\d{4})?",
    WF: "986\\d{2}",
    XK: "\\d{5}",
    YT: "976\\d{2}",
    YU: "\\d{5}",
    ZA: "\\d{4}",
    ZM: "\\d{5}"
  }
}, a = {
  supplemental: _
}, { postalCodeData: o } = a.supplemental, i = /* @__PURE__ */ new Map();
function n(e) {
  return Reflect.has(o, e);
}
function d(e) {
  return Object.entries(e);
}
const C = new Map(
  d(o)
);
function l(e, s) {
  if (!n(e))
    return !1;
  const r = i.get(e);
  return r ? r.test(s) : (i.set(e, new RegExp(`^${o[e]}$`)), l(e, s));
}
const p = [
  {
    dnc: "clothing__mixed_shoes",
    stripe: "shoe_stores"
  },
  {
    dnc: "clothing__socks_tights",
    stripe: "commercial_footwear"
  },
  {
    dnc: "clothing__children_infant_clothing",
    stripe: "childrens_and_infants_wear_stores"
  },
  {
    dnc: "clothing__mixed_clothing",
    stripe: "mens_womens_clothing_stores"
  },
  {
    dnc: "clothing__men_clothing",
    stripe: "mens_and_boys_clothing_and_accessories_stores"
  },
  {
    dnc: "clothing__women_clothing",
    stripe: "womens_ready_to_wear_stores"
  },
  {
    dnc: "clothing__various_accessories",
    stripe: "miscellaneous_apparel_and_accessory_shops"
  },
  {
    dnc: "clothing__men_underwear",
    stripe: "mens_and_boys_clothing_and_accessories_stores"
  },
  {
    dnc: "clothing__women_underwear",
    stripe: "womens_ready_to_wear_stores"
  },
  {
    dnc: "accessories__leather_goods_luggage",
    stripe: "luggage_and_leather_goods_stores"
  },
  {
    dnc: "accessories__fashion_jewelry",
    stripe: "jewelry_stores_watches_clocks_and_silverware_stores"
  },
  {
    dnc: "accessories__jewelry",
    stripe: "precious_stones_and_metals_watches_and_jewelry"
  },
  {
    dnc: "accessories__telephony",
    stripe: "telecommunication_equipment_and_telephone_sales"
  },
  {
    dnc: "accessories__glasses_optics",
    stripe: "opticians_eyeglasses"
  },
  {
    dnc: "accessories__watches",
    stripe: "precious_stones_and_metals_watches_and_jewelry"
  },
  {
    dnc: "accessories__animals",
    stripe: "pet_shops_pet_food_and_supplies"
  },
  {
    dnc: "accessories__other",
    stripe: "miscellaneous_apparel_and_accessory_shops"
  },
  {
    dnc: "wellness_beauty__makeup_manicure",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__solid_cosmetics",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__skincare",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__hair_products",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__men_cosmetics",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__perfumes",
    stripe: "cosmetic_stores"
  },
  {
    dnc: "wellness_beauty__food_supplements",
    stripe: "miscellaneous_food_stores"
  },
  {
    dnc: "wellness_beauty__intimate_pleasure",
    stripe: "womens_accessory_and_specialty_shops"
  },
  {
    dnc: "childhood__clothing_accessories",
    stripe: "childrens_and_infants_wear_stores"
  },
  {
    dnc: "childhood__leisure",
    stripe: "hobby_toy_and_game_shops"
  },
  {
    dnc: "childhood__food",
    stripe: "miscellaneous_food_stores"
  },
  {
    dnc: "home__plants_flowers",
    stripe: "florists"
  },
  {
    dnc: "home__decoration_furnishings",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__bedding",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__cleaning_products",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__candles",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__household_linen",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__kitchen_accessories",
    stripe: "furniture_home_furnishings_and_equipment_stores_except_appliances"
  },
  {
    dnc: "home__household_appliances",
    stripe: "household_appliance_stores"
  },
  {
    dnc: "sports_leisure__equipment",
    stripe: "sporting_goods_stores"
  },
  {
    dnc: "sports_leisure__bicycle",
    stripe: "bicycle_shops"
  },
  {
    dnc: "sports_leisure__automobile",
    stripe: "automotive_parts_and_accessories_stores"
  },
  {
    dnc: "sports_leisure__motorcycle",
    stripe: "motorcycle_shops_and_dealers"
  },
  {
    dnc: "sports_leisure__games",
    stripe: "hobby_toy_and_game_shops"
  },
  {
    dnc: "food_beverage__drinks",
    stripe: "miscellaneous_food_stores"
  },
  {
    dnc: "food_beverage__food",
    stripe: "miscellaneous_food_stores"
  },
  {
    dnc: "food_beverage__pet_food",
    stripe: "pet_shops_pet_food_and_supplies"
  },
  {
    dnc: "digital_products__gift_cards",
    stripe: "gift_card_novelty_and_souvenir_shops"
  },
  {
    dnc: "digital_products__books",
    stripe: "digital_goods_media"
  },
  {
    dnc: "digital_products__films_multimedia",
    stripe: "digital_goods_media"
  },
  {
    dnc: "digital_products__music",
    stripe: "digital_goods_media"
  },
  {
    dnc: "digital_products__games",
    stripe: "digital_goods_games"
  },
  {
    dnc: "digital_products__other_digital_assets",
    stripe: "digital_goods_large_volume"
  },
  {
    dnc: "art__galleries_art_dealers",
    stripe: "art_dealers_and_galleries"
  },
  {
    dnc: "art__artist_supplies",
    stripe: "artists_supply_and_craft_shops"
  },
  {
    dnc: "electronic_products__electronic_products",
    stripe: "electronics_stores"
  },
  {
    dnc: "other_merchandise__other_merchandise",
    stripe: "miscellaneous_general_merchandise"
  }
], m = [
  {
    mcc: "1520",
    descriptionCode: "general_services",
    category: "contracted_services"
  },
  {
    mcc: "1711",
    descriptionCode: "heating_plumbing_a_c",
    category: "contracted_services"
  },
  {
    mcc: "1731",
    descriptionCode: "electrical_services",
    category: "contracted_services"
  },
  {
    mcc: "1740",
    descriptionCode: "masonry_stonework_and_plaster",
    category: "contracted_services"
  },
  {
    mcc: "1750",
    descriptionCode: "carpentry_services",
    category: "contracted_services"
  },
  {
    mcc: "1761",
    descriptionCode: "roofing_siding_sheet_metal",
    category: "contracted_services"
  },
  {
    mcc: "1771",
    descriptionCode: "concrete_work_services",
    category: "contracted_services"
  },
  {
    mcc: "1799",
    descriptionCode: "special_trade_services",
    category: "contracted_services"
  },
  {
    mcc: "2741",
    descriptionCode: "miscellaneous_publishing_and_printing",
    category: "contracted_services"
  },
  {
    mcc: "2791",
    descriptionCode: "typesetting_plate_making_and_related_services",
    category: "contracted_services"
  },
  {
    mcc: "2842",
    descriptionCode: "specialty_cleaning",
    category: "contracted_services"
  },
  {
    mcc: "4011",
    descriptionCode: "railroads",
    category: "transportation_services"
  },
  {
    mcc: "4111",
    descriptionCode: "commuter_transport_and_ferries",
    category: "transportation_services"
  },
  {
    mcc: "4112",
    descriptionCode: "passenger_railways",
    category: "transportation_services"
  },
  {
    mcc: "4119",
    descriptionCode: "ambulance_services",
    category: "transportation_services"
  },
  {
    mcc: "4121",
    descriptionCode: "taxicabs_limousines",
    category: "transportation_services"
  },
  {
    mcc: "4131",
    descriptionCode: "bus_lines",
    category: "transportation_services"
  },
  {
    mcc: "4214",
    descriptionCode: "motor_freight_carriers_and_trucking",
    category: "transportation_services"
  },
  {
    mcc: "4215",
    descriptionCode: "courier_services",
    category: "transportation_services"
  },
  {
    mcc: "4225",
    descriptionCode: "public_warehousing_and_storage",
    category: "transportation_services"
  },
  {
    mcc: "4411",
    descriptionCode: "cruise_lines",
    category: "transportation_services"
  },
  {
    mcc: "4457",
    descriptionCode: "boat_rentals_and_leases",
    category: "transportation_services"
  },
  {
    mcc: "4468",
    descriptionCode: "marinas_service_and_supplies",
    category: "transportation_services"
  },
  {
    mcc: "4511",
    descriptionCode: "airlines_air_carriers",
    category: "transportation_services"
  },
  {
    mcc: "4582",
    descriptionCode: "airports_flying_fields",
    category: "transportation_services"
  },
  {
    mcc: "4722",
    descriptionCode: "travel_agencies_tour_operators",
    category: "transportation_services"
  },
  {
    mcc: "4723",
    descriptionCode: "t_ui_travel_germany",
    category: "transportation_services"
  },
  {
    mcc: "4784",
    descriptionCode: "tolls_bridge_fees",
    category: "transportation_services"
  },
  {
    mcc: "4789",
    descriptionCode: "transportation_services",
    category: "transportation_services"
  },
  {
    mcc: "4812",
    descriptionCode: "telecommunication_equipment_and_telephone_sales",
    category: "utility_services"
  },
  {
    mcc: "4814",
    descriptionCode: "telecommunication_services",
    category: "utility_services"
  },
  {
    mcc: "4816",
    descriptionCode: "computer_network_services",
    category: "utility_services"
  },
  {
    mcc: "4821",
    descriptionCode: "telegraph_services",
    category: "utility_services"
  },
  {
    mcc: "4829",
    descriptionCode: "wires_money_orders",
    category: "utility_services"
  },
  {
    mcc: "4899",
    descriptionCode: "cable_satellite_and_other_pay_television_and_radio",
    category: "utility_services"
  },
  {
    mcc: "4900",
    descriptionCode: "utilities",
    category: "utility_services"
  },
  {
    mcc: "5013",
    descriptionCode: "motor_vehicle_supplies_and_new_parts",
    category: "retail_outlet_services"
  },
  {
    mcc: "5021",
    descriptionCode: "office_and_commercial_furniture",
    category: "retail_outlet_services"
  },
  {
    mcc: "5039",
    descriptionCode: "construction_materials",
    category: "retail_outlet_services"
  },
  {
    mcc: "5044",
    descriptionCode: "photographic_photocopy_microfilm_equipment_and_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5045",
    descriptionCode: "computers_peripherals_and_software",
    category: "retail_outlet_services"
  },
  {
    mcc: "5046",
    descriptionCode: "commercial_equipment",
    category: "retail_outlet_services"
  },
  {
    mcc: "5047",
    descriptionCode: "medical_dental_ophthalmic_and_hospital_equipment_and_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5051",
    descriptionCode: "metal_service_centers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5065",
    descriptionCode: "electrical_parts_and_equipment",
    category: "retail_outlet_services"
  },
  {
    mcc: "5072",
    descriptionCode: "hardware_equipment_and_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5074",
    descriptionCode: "plumbing_heating_equipment_and_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5085",
    descriptionCode: "industrial_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5094",
    descriptionCode: "precious_stones_and_metals_watches_and_jewelry",
    category: "retail_outlet_services"
  },
  {
    mcc: "5099",
    descriptionCode: "durable_goods",
    category: "retail_outlet_services"
  },
  {
    mcc: "5111",
    descriptionCode: "stationary_office_supplies_printing_and_writing_paper",
    category: "retail_outlet_services"
  },
  {
    mcc: "5122",
    descriptionCode: "drugs_drug_proprietaries_and_druggist_sundries",
    category: "retail_outlet_services"
  },
  {
    mcc: "5131",
    descriptionCode: "piece_goods_notions_and_other_dry_goods",
    category: "retail_outlet_services"
  },
  {
    mcc: "5137",
    descriptionCode: "uniforms_commercial_clothing",
    category: "retail_outlet_services"
  },
  {
    mcc: "5139",
    descriptionCode: "commercial_footwear",
    category: "retail_outlet_services"
  },
  {
    mcc: "5169",
    descriptionCode: "chemicals_and_allied_products",
    category: "retail_outlet_services"
  },
  {
    mcc: "5172",
    descriptionCode: "petroleum_and_petroleum_products",
    category: "retail_outlet_services"
  },
  {
    mcc: "5192",
    descriptionCode: "books_periodicals_and_newspapers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5193",
    descriptionCode: "florists_supplies_nursery_stock_and_flowers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5198",
    descriptionCode: "paints_varnishes_and_supplies",
    category: "retail_outlet_services"
  },
  {
    mcc: "5199",
    descriptionCode: "nondurable_goods",
    category: "retail_outlet_services"
  },
  {
    mcc: "5200",
    descriptionCode: "home_supply_warehouse_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5211",
    descriptionCode: "lumber_building_materials_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5231",
    descriptionCode: "glass_paint_and_wallpaper_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5251",
    descriptionCode: "hardware_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5261",
    descriptionCode: "nurseries_lawn_and_garden_supply_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5271",
    descriptionCode: "mobile_home_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5300",
    descriptionCode: "wholesale_clubs",
    category: "retail_outlet_services"
  },
  {
    mcc: "5309",
    descriptionCode: "duty_free_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5310",
    descriptionCode: "discount_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5311",
    descriptionCode: "department_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5331",
    descriptionCode: "variety_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5399",
    descriptionCode: "miscellaneous_general_merchandise",
    category: "retail_outlet_services"
  },
  {
    mcc: "5411",
    descriptionCode: "grocery_stores_supermarkets",
    category: "retail_outlet_services"
  },
  {
    mcc: "5422",
    descriptionCode: "freezer_and_locker_meat_provisioners",
    category: "retail_outlet_services"
  },
  {
    mcc: "5441",
    descriptionCode: "candy_nut_and_confectionery_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5451",
    descriptionCode: "dairy_products_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5462",
    descriptionCode: "bakeries",
    category: "retail_outlet_services"
  },
  {
    mcc: "5499",
    descriptionCode: "miscellaneous_food_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5511",
    descriptionCode: "car_and_truck_dealers_new_used",
    category: "retail_outlet_services"
  },
  {
    mcc: "5521",
    descriptionCode: "car_and_truck_dealers_used_only",
    category: "retail_outlet_services"
  },
  {
    mcc: "5531",
    descriptionCode: "auto_and_home_supply_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5532",
    descriptionCode: "automotive_tire_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5533",
    descriptionCode: "automotive_parts_and_accessories_stores",
    category: "retail_outlet_services"
  },
  {
    mcc: "5541",
    descriptionCode: "service_stations",
    category: "retail_outlet_services"
  },
  {
    mcc: "5542",
    descriptionCode: "automated_fuel_dispensers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5551",
    descriptionCode: "boat_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5561",
    descriptionCode: "motorcycle_shops_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5571",
    descriptionCode: "motorcycle_shops_and_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5592",
    descriptionCode: "motor_homes_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5598",
    descriptionCode: "snowmobile_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5599",
    descriptionCode: "miscellaneous_auto_dealers",
    category: "retail_outlet_services"
  },
  {
    mcc: "5611",
    descriptionCode: "mens_and_boys_clothing_and_accessories_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5621",
    descriptionCode: "womens_ready_to_wear_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5631",
    descriptionCode: "womens_accessory_and_specialty_shops",
    category: "clothing_stores"
  },
  {
    mcc: "5641",
    descriptionCode: "childrens_and_infants_wear_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5651",
    descriptionCode: "family_clothing_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5655",
    descriptionCode: "sports_and_riding_apparel_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5661",
    descriptionCode: "shoe_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5681",
    descriptionCode: "furriers_and_fur_shops",
    category: "clothing_stores"
  },
  {
    mcc: "5691",
    descriptionCode: "mens_womens_clothing_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5697",
    descriptionCode: "tailors_alterations",
    category: "clothing_stores"
  },
  {
    mcc: "5698",
    descriptionCode: "wig_and_toupee_stores",
    category: "clothing_stores"
  },
  {
    mcc: "5699",
    descriptionCode: "miscellaneous_apparel_and_accessory_shops",
    category: "clothing_stores"
  },
  {
    mcc: "5712",
    descriptionCode: "furniture_home_furnishings_and_equipment_stores_except_appliances",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5713",
    descriptionCode: "floor_covering_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5714",
    descriptionCode: "drapery_window_covering_and_upholstery_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5718",
    descriptionCode: "fireplace_fireplace_screens_and_accessories_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5719",
    descriptionCode: "miscellaneous_home_furnishing_specialty_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5722",
    descriptionCode: "household_appliance_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5732",
    descriptionCode: "electronics_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5733",
    descriptionCode: "music_stores_musical_instruments_pianos_and_sheet_music",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5734",
    descriptionCode: "computer_software_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5735",
    descriptionCode: "record_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5811",
    descriptionCode: "caterers",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5812",
    descriptionCode: "eating_places_restaurants",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5813",
    descriptionCode: "drinking_places",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5814",
    descriptionCode: "fast_food_restaurants",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5815",
    descriptionCode: "digital_goods_media",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5816",
    descriptionCode: "digital_goods_games",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5817",
    descriptionCode: "digital_goods_applications",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5818",
    descriptionCode: "digital_goods_large_volume",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5912",
    descriptionCode: "drug_stores_and_pharmacies",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5921",
    descriptionCode: "package_stores_beer_wine_and_liquor",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5931",
    descriptionCode: "used_merchandise_and_secondhand_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5932",
    descriptionCode: "antique_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5933",
    descriptionCode: "pawn_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5935",
    descriptionCode: "wrecking_and_salvage_yards",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5937",
    descriptionCode: "antique_reproductions",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5940",
    descriptionCode: "bicycle_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5941",
    descriptionCode: "sporting_goods_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5942",
    descriptionCode: "book_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5943",
    descriptionCode: "stationery_stores_office_and_school_supply_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5944",
    descriptionCode: "jewelry_stores_watches_clocks_and_silverware_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5945",
    descriptionCode: "hobby_toy_and_game_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5946",
    descriptionCode: "camera_and_photographic_supply_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5947",
    descriptionCode: "gift_card_novelty_and_souvenir_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5948",
    descriptionCode: "luggage_and_leather_goods_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5949",
    descriptionCode: "sewing_needlework_fabric_and_piece_goods_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5950",
    descriptionCode: "glassware_crystal_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5960",
    descriptionCode: "direct_marketing_insurance_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5962",
    descriptionCode: "direct_marketing_travel",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5963",
    descriptionCode: "door_to_door_sales",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5964",
    descriptionCode: "direct_marketing_catalog_merchant",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5965",
    descriptionCode: "direct_marketing_combination_catalog_and_retail_merchant",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5966",
    descriptionCode: "direct_marketing_outbound_telemarketing",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5967",
    descriptionCode: "direct_marketing_inbound_telemarketing",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5968",
    descriptionCode: "direct_marketing_subscription",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5969",
    descriptionCode: "direct_marketing_other",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5970",
    descriptionCode: "artists_supply_and_craft_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5971",
    descriptionCode: "art_dealers_and_galleries",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5972",
    descriptionCode: "stamp_and_coin_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5973",
    descriptionCode: "religious_goods_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5975",
    descriptionCode: "hearing_aids_sales_and_supplies",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5976",
    descriptionCode: "orthopedic_goods_prosthetic_devices",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5977",
    descriptionCode: "cosmetic_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5978",
    descriptionCode: "typewriter_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5983",
    descriptionCode: "fuel_dealers_non_automotive",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5992",
    descriptionCode: "florists",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5993",
    descriptionCode: "cigar_stores_and_stands",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5994",
    descriptionCode: "news_dealers_and_newsstands",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5995",
    descriptionCode: "pet_shops_pet_food_and_supplies",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5996",
    descriptionCode: "swimming_pools_sales",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5997",
    descriptionCode: "electric_razor_stores",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5998",
    descriptionCode: "tent_and_awning_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "5999",
    descriptionCode: "miscellaneous_specialty_retail",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6010",
    descriptionCode: "manual_cash_disburse",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6011",
    descriptionCode: "automated_cash_disburse",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6012",
    descriptionCode: "financial_institutions",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6051",
    descriptionCode: "non_fi_money_orders",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6211",
    descriptionCode: "security_brokers_dealers",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6300",
    descriptionCode: "insurance_underwriting_premiums",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6399",
    descriptionCode: "insurance_default",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6513",
    descriptionCode: "real_estate_agents_and_managers_rentals",
    category: "miscellaneous_stores"
  },
  {
    mcc: "6540",
    descriptionCode: "non_fi_stored_value_card_purchase_load",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7011",
    descriptionCode: "hotels_motels_and_resorts",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7012",
    descriptionCode: "timeshares",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7032",
    descriptionCode: "sporting_recreation_camps",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7033",
    descriptionCode: "trailer_parks_campgrounds",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7210",
    descriptionCode: "laundry_cleaning_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7211",
    descriptionCode: "laundries",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7216",
    descriptionCode: "dry_cleaners",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7217",
    descriptionCode: "carpet_upholstery_cleaning",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7221",
    descriptionCode: "photographic_studios",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7230",
    descriptionCode: "barber_and_beauty_shops",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7251",
    descriptionCode: "shoe_repair_hat_cleaning",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7261",
    descriptionCode: "funeral_services_crematories",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7273",
    descriptionCode: "dating_escort_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7276",
    descriptionCode: "tax_preparation_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7277",
    descriptionCode: "counseling_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7278",
    descriptionCode: "buying_shopping_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7296",
    descriptionCode: "clothing_rental",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7297",
    descriptionCode: "massage_parlors",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7298",
    descriptionCode: "health_and_beauty_spas",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7299",
    descriptionCode: "miscellaneous_general_services",
    category: "miscellaneous_stores"
  },
  {
    mcc: "7311",
    descriptionCode: "advertising_services",
    category: "business_services"
  },
  {
    mcc: "7321",
    descriptionCode: "credit_reporting_agencies",
    category: "business_services"
  },
  {
    mcc: "7333",
    descriptionCode: "commercial_photography_art_and_graphics",
    category: "business_services"
  },
  {
    mcc: "7338",
    descriptionCode: "quick_copy_repro_and_blueprint",
    category: "business_services"
  },
  {
    mcc: "7339",
    descriptionCode: "secretarial_support_services",
    category: "business_services"
  },
  {
    mcc: "7342",
    descriptionCode: "exterminating_services",
    category: "business_services"
  },
  {
    mcc: "7349",
    descriptionCode: "cleaning_and_maintenance",
    category: "business_services"
  },
  {
    mcc: "7361",
    descriptionCode: "employment_temp_agencies",
    category: "business_services"
  },
  {
    mcc: "7372",
    descriptionCode: "computer_programming",
    category: "business_services"
  },
  {
    mcc: "7375",
    descriptionCode: "information_retrieval_services",
    category: "business_services"
  },
  {
    mcc: "7379",
    descriptionCode: "computer_repair",
    category: "business_services"
  },
  {
    mcc: "7392",
    descriptionCode: "consulting_public_relations",
    category: "business_services"
  },
  {
    mcc: "7393",
    descriptionCode: "detective_agencies",
    category: "business_services"
  },
  {
    mcc: "7394",
    descriptionCode: "equipment_rental",
    category: "business_services"
  },
  {
    mcc: "7395",
    descriptionCode: "photo_developing",
    category: "business_services"
  },
  {
    mcc: "7399",
    descriptionCode: "miscellaneous_business_services",
    category: "business_services"
  },
  {
    mcc: "7511",
    descriptionCode: "truck_stop_iteration",
    category: "business_services"
  },
  {
    mcc: "7512",
    descriptionCode: "car_rental_agencies",
    category: "business_services"
  },
  {
    mcc: "7513",
    descriptionCode: "truck_utility_trailer_rentals",
    category: "business_services"
  },
  {
    mcc: "7519",
    descriptionCode: "recreational_vehicle_rentals",
    category: "business_services"
  },
  {
    mcc: "7523",
    descriptionCode: "parking_lots_garages",
    category: "business_services"
  },
  {
    mcc: "7531",
    descriptionCode: "auto_body_repair_shops",
    category: "business_services"
  },
  {
    mcc: "7534",
    descriptionCode: "tire_retreading_and_repair",
    category: "business_services"
  },
  {
    mcc: "7535",
    descriptionCode: "auto_paint_shops",
    category: "business_services"
  },
  {
    mcc: "7538",
    descriptionCode: "auto_service_shops",
    category: "business_services"
  },
  {
    mcc: "7542",
    descriptionCode: "car_washes",
    category: "business_services"
  },
  {
    mcc: "7549",
    descriptionCode: "towing_services",
    category: "business_services"
  },
  {
    mcc: "7622",
    descriptionCode: "electronics_repair_shops",
    category: "business_services"
  },
  {
    mcc: "7623",
    descriptionCode: "ac_refrigeration_repair",
    category: "business_services"
  },
  {
    mcc: "7629",
    descriptionCode: "small_appliance_repair",
    category: "business_services"
  },
  {
    mcc: "7631",
    descriptionCode: "watch_jewelry_repair",
    category: "business_services"
  },
  {
    mcc: "7641",
    descriptionCode: "furniture_repair_refinishing",
    category: "business_services"
  },
  {
    mcc: "7692",
    descriptionCode: "welding_repair",
    category: "business_services"
  },
  {
    mcc: "7699",
    descriptionCode: "miscellaneous_repair_shops",
    category: "business_services"
  },
  {
    mcc: "7829",
    descriptionCode: "picture_video_production",
    category: "business_services"
  },
  {
    mcc: "7832",
    descriptionCode: "motion_picture_theaters",
    category: "business_services"
  },
  {
    mcc: "7841",
    descriptionCode: "video_tape_rental_stores",
    category: "business_services"
  },
  {
    mcc: "7911",
    descriptionCode: "dance_hall_studios_schools",
    category: "business_services"
  },
  {
    mcc: "7922",
    descriptionCode: "theatrical_ticket_agencies",
    category: "business_services"
  },
  {
    mcc: "7929",
    descriptionCode: "bands_orchestras",
    category: "business_services"
  },
  {
    mcc: "7932",
    descriptionCode: "billiard_pool_establishments",
    category: "business_services"
  },
  {
    mcc: "7933",
    descriptionCode: "bowling_alleys",
    category: "business_services"
  },
  {
    mcc: "7941",
    descriptionCode: "sports_clubs_fields",
    category: "business_services"
  },
  {
    mcc: "7991",
    descriptionCode: "tourist_attractions_and_exhibits",
    category: "business_services"
  },
  {
    mcc: "7992",
    descriptionCode: "golf_courses_public",
    category: "business_services"
  },
  {
    mcc: "7993",
    descriptionCode: "video_amusement_game_supplies",
    category: "business_services"
  },
  {
    mcc: "7994",
    descriptionCode: "video_game_arcades",
    category: "business_services"
  },
  {
    mcc: "7995",
    descriptionCode: "betting_casino_gambling",
    category: "business_services"
  },
  {
    mcc: "7996",
    descriptionCode: "amusement_parks_carnivals",
    category: "business_services"
  },
  {
    mcc: "7997",
    descriptionCode: "country_clubs",
    category: "business_services"
  },
  {
    mcc: "7998",
    descriptionCode: "aquariums",
    category: "business_services"
  },
  {
    mcc: "7999",
    descriptionCode: "miscellaneous_recreation_services",
    category: "business_services"
  },
  {
    mcc: "8011",
    descriptionCode: "doctors",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8021",
    descriptionCode: "dentists_orthodontists",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8031",
    descriptionCode: "osteopaths",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8041",
    descriptionCode: "chiropractors",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8042",
    descriptionCode: "optometrists_ophthalmologist",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8043",
    descriptionCode: "opticians_eyeglasses",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8049",
    descriptionCode: "chiropodists_podiatrists",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8050",
    descriptionCode: "nursing_personal_care",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8062",
    descriptionCode: "hospitals",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8071",
    descriptionCode: "medical_and_dental_labs",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8099",
    descriptionCode: "medical_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8111",
    descriptionCode: "legal_services_attorneys",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8211",
    descriptionCode: "elementary_secondary_schools",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8220",
    descriptionCode: "colleges_universities",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8241",
    descriptionCode: "correspondence_schools",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8244",
    descriptionCode: "business_secretarial_schools",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8249",
    descriptionCode: "vocational_trade_schools",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8299",
    descriptionCode: "educational_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8351",
    descriptionCode: "child_care_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8398",
    descriptionCode: "charitable_and_social_service_organizations_fundraising",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8641",
    descriptionCode: "civic_social_fraternal_associations",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8651",
    descriptionCode: "political_organizations",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8661",
    descriptionCode: "religious_organizations",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8675",
    descriptionCode: "automobile_associations",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8699",
    descriptionCode: "membership_organizations",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8734",
    descriptionCode: "testing_laboratories",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8911",
    descriptionCode: "architectural_surveying_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8931",
    descriptionCode: "accounting_bookkeeping_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "8999",
    descriptionCode: "professional_services",
    category: "professional_services_and_membership_organizations"
  },
  {
    mcc: "9211",
    descriptionCode: "court_costs",
    category: "government_services"
  },
  {
    mcc: "9222",
    descriptionCode: "fines_government_administrative_entities",
    category: "government_services"
  },
  {
    mcc: "9223",
    descriptionCode: "bail_and_bond_payments",
    category: "government_services"
  },
  {
    mcc: "9311",
    descriptionCode: "tax_payments_government_agencies",
    category: "government_services"
  },
  {
    mcc: "9399",
    descriptionCode: "government_services",
    category: "government_services"
  },
  {
    mcc: "9402",
    descriptionCode: "postal_services_government_only",
    category: "government_services"
  },
  {
    mcc: "9405",
    descriptionCode: "u_s_federal_government_agencies_or_departments",
    category: "government_services"
  },
  {
    mcc: "9950",
    descriptionCode: "intra_company_purchases",
    category: "government_services"
  },
  {
    mcc: "0763",
    descriptionCode: "agricultural_cooperative",
    category: "agricultural_services"
  },
  {
    mcc: "0780",
    descriptionCode: "landscaping_services",
    category: "agricultural_services"
  },
  {
    mcc: "0742",
    descriptionCode: "veterinary_services",
    category: "agricultural_services"
  }
], c = new Map(p.map(({ dnc: e, stripe: s }) => [e, s])), g = new Map(m.map(({ mcc: e, descriptionCode: s }) => [s, e]));
function v(e) {
  return g.get(c.get(e) ?? "");
}
const u = Array.from(c.keys());
function h(e) {
  return c.has(e);
}
const b = t.enum(Array.from(u));
export {
  b as ZMcc,
  u as allMcc,
  v as dncMccToCode,
  h as isMccValid,
  l as isPostalCodeValid,
  C as postalCodeRegexByCountry
};
